export default __webpack_public_path__ + "static/media/npm.ad11c6b4.svg";